<template>
  <ion-page>
    <ion-content class="white">
      <ion-header style="font-weight: bold" class="ion-margin-bottom ion-margin-top ion-text-center">パスワードの更新</ion-header>
      <div class="ion-padding">
        <div class="ion-padding-horizontal">
          <required-input label="新しいパスワード" class="ion-margin-top"></required-input>
          <ion-input
            id="password"
            v-model="password"
            type="password"
            name="password"
            placeholder="新しいパスワードを入力"
            label-placement="stacked"
            helper-text="パスワードは半角8〜20文字、英字・数字混在で入力してください"
            fill="outline"
            mode="md"
            color="dark"
            :class="{ 'border-danger': (errors && errors.password)}"
          ></ion-input>
          <ion-text color="danger" v-if="errors && errors.password">{{ errors.password }}</ion-text>
          <required-input label="新しいパスワード（確認用）" class="ion-margin-top"></required-input>
          <ion-input
            id="password_confirmation"
            v-model="password_confirmation"
            type="password"
            name="password_confirmation"
            placeholder="新しいパスワード（確認用）を入力"
            label-placement="stacked"
            helper-text="パスワードは半角8〜20文字、英字・数字混在で入力してください"
            fill="outline"
            mode="md"
            color="dark"
            :class="{ 'border-danger': (errors && errors.password_confirmation)}"
          ></ion-input>
          <ion-text color="danger" v-if="errors && errors.password_confirmation">{{ errors.password_confirmation }}</ion-text>
          <ion-button class="ion-margin-top primary-button" expand="block" @click="registerSubmit">パスワードを更新する ></ion-button>
          <ion-button class="ion-margin-top secondary-button" expand="block" fill="outline" @click="goToLoginPage()">ログイン画面に戻る ></ion-button>
        </div>
      </div>
    </ion-content>
    <ion-loading trigger="open-loading" :duration="3000" message="処理中..."></ion-loading>
  </ion-page>
</template>

<script setup lang="ts">
import { useForm, useFormErrors, useField } from 'vee-validate';
import * as yup from 'yup';
import {
  IonPage,
  IonHeader,
  IonContent,
  IonLoading,
  loadingController,
  LoadingOptions,
  IonLabel,
  IonText,
  IonInput,
  IonButton,
  type SelectCustomEvent,
} from "@ionic/vue";

import RequiredInput from "@/components/RequiredInput.vue";
import request from '../../utils/Request'
import { Device } from '@capacitor/device';
import {useRoute, useRouter} from 'vue-router';
import StorageService from '../../utils/StorageService'
import {goToLoginPage} from "@/helpers/platform";

const router = useRouter()

const schema = yup.object({
  password: yup.string()
    .min(8, 'パスワードは半角英数8文字以上、255文字以内でご入力ください')
    .max(255, 'パスワードは半角英数8文字以上、255文字以内でご入力ください')
    .matches(/^[a-zA-Z0-9]+$/, 'パスワードは半角英数8文字以上、255文字以内でご入力ください')
    .required('パスワードは必ず指定してください。'),
  password_confirmation: yup.string()
    .required('確認用パスワードをご入力ください'),
})

const form = useForm({
  validationSchema: schema
})

const { value: password } = useField<string>("password")
const { value: password_confirmation } = useField<string>("password_confirmation")

const errors = useFormErrors() as any;
const route = useRoute()

async function registerSubmit() {
  const resp = await form.validate();

  if (resp.valid) {
    submitForm(form)
  }
}
async function submitForm (form: any) {
  const deviceInfo = await Device.getInfo()
  const data = {...form.values, ...{
    email: route.query.email,
    code: route.query.code,
    app_id: import.meta.env.VITE_APP_ID,
    device_uuid: await StorageService.get('deviceUuid'),
    osVersion: deviceInfo.osVersion,
    os: deviceInfo.operatingSystem
  }}

  const loading = await createLoading('送信処理中...')
  await loading.present()
  request.post('/reset-password-no-login', data).then((res) => {
    if (res.status) {
      router.push({name: 'CompletedUpdateForgotPassword'})
    }
  }).catch((err) => {
    if (err.response?.status == 422) {
      form.setErrors(err.response.data.errors);
    }
  }).finally(() => {
    loading.dismiss()
  })
}

async function createLoading(msg: string, duration?: number, spinner: LoadingOptions["spinner"] = "crescent") {
  return await loadingController.create({
    message: msg,
    duration: duration,
    spinner: spinner,
  })
}
</script>

<style scoped></style>
